// src/stores/mutedStore.ts
import { writable } from 'svelte/store';

export const autoScrollStore = writable({
    enabled: false,
});

export function toggleAutoScroll() {
    autoScrollStore.update((store) => {
        store.enabled = !store.enabled;
        return store;
    });
}
